import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './why-trust-us.css';

import { FaShieldAlt, FaUserCheck, FaRupeeSign, FaStar } from 'react-icons/fa';

const WhyTrustUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const trustPoints = [
    {
      icon: <FaShieldAlt size={30} />,
      title: 'Secure & Private',
      desc: 'We employ bank-grade encryption to ensure your data remains confidential and protected.',
      delay: 0,
    },
    {
      icon: <FaUserCheck size={30} />,
      title: 'Trusted by Thousands',
      desc: 'Join over 50,000 salaried professionals who choose us for secure, prompt financial support.',
      delay: 100,
    },
    {
      icon: <FaRupeeSign size={30} />,
      title: 'Instant Disbursal',
      desc: 'Receive funds directly in your account within hours of approval—no unnecessary delays.',
      delay: 200,
    },
    {
      icon: <FaStar size={30} />,
      title: 'Transparent Process',
      desc: 'No hidden fees, no surprises—just clear, straightforward terms you can trust.',
      delay: 300,
    },
  ];

  return (
    <section className="trust-section py-5 bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title fw-bold">WHY TRUST US</h2>
          <p className="trust-subtext">We make borrowing secure, simple, and stress-free.</p>
        </div>

        <div className="row g-4">
          {trustPoints.map((point, index) => (
            <div
              className="col-md-6 col-lg-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={point.delay}
            >
              <div className="card trust-card-box text-center border-0 shadow h-100">
                <div className="card-body">
                  <div className="trust-icon mb-3">{point.icon}</div>
                  <h5 className="fw-bold">{point.title}</h5>
                  <p className="text-muted small">{point.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyTrustUs;
